module.exports = __webpack_public_path__ + "img/t2-i3.b9d2acab.png";